import { FC } from "react";
import { ViewProps } from "../types";
import { useRouter } from "next/router";
import routes from "@/utils/wroutes";

export type WithActionsProps = {
  handlePostClick: (slug: string) => void;
};

export const withActions =
  (View: FC<WithActionsProps>) => (props: ViewProps) => {
    const router = useRouter();

    const handlePostClick = (slug: string) => {
      router.push(routes.blog.blogPost(slug));
    };

    return <View {...props} handlePostClick={handlePostClick} />;
  };
